var util = require('util')
  , request = require('../index')
  ;

module.exports = function debug() {
  if (request.debug) {
    console.error('REQUEST %s', util.format.apply(util, arguments))
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/fhir.js/~/request/lib/debug.js
// module id = 1250
// module chunks = 0